import { defineField, defineType } from 'sanity'
import { buttonThemeFields } from './buttonThemeFields'
import { internalPages } from '../../structure/deskStructure'

export default defineType({
  name: 'link',
  type: 'object',
  title: 'Link',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Type',
      name: 'type',
      type: 'string',
      options: {
        list: [
          { title: 'Internal', value: 'internal' },
          { title: 'External', value: 'external' },
          { title: 'Vehicle Selector', value: 'vehicleSelector' },
          { title: 'Custom', value: 'custom' },
        ],
      },
      initialValue: 'custom',
    }),
    defineField({
      title: 'URL (i)',
      name: 'url_internal',
      description: 'Search for internal page.',
      type: 'reference',
      to: internalPages.map((page) => ({ type: page })),
      hidden: ({ parent }) => parent?.type !== 'internal',
      options: {
        disableNew: true,
      },
    }),
    defineField({
      title: 'URL (e)',
      name: 'url_external',
      type: 'url',
      hidden: ({ parent }) => parent?.type !== 'external',
      validation: (rule) =>
        rule.uri({
          allowRelative: true,
          scheme: ['https', 'http', 'mailto', 'tel'],
        }),
    }),
    defineField({
      title: 'URL (c)',
      name: 'url_custom',
      type: 'string',
      initialValue: '#url',
      hidden: ({ parent }) => parent?.type !== 'custom',
    }),
    defineField({
      title: 'Target',
      name: 'target',
      type: 'string',
      options: {
        list: [
          { title: 'Self', value: '_self' },
          { title: 'New Window', value: '_blank' },
        ],
      },
      initialValue: '_self',
      hidden: ({ parent }) => parent?.type === 'vehicleSelector',
    }),
    ...buttonThemeFields,
  ],
})